import { render, staticRenderFns } from "./filePhone.vue?vue&type=template&id=7efafa12&scoped=true"
import script from "./filePhone.vue?vue&type=script&lang=js"
export * from "./filePhone.vue?vue&type=script&lang=js"
import style0 from "./filePhone.vue?vue&type=style&index=0&id=7efafa12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efafa12",
  null
  
)

export default component.exports